import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ActionIcon } from '@mantine/core';
import { ChevronDown, ChevronUp } from 'tabler-icons-react';
import { useMediaQueryIndex } from '../../helpers/hooks';
import PageCard from './PageCard';
import AppStack from './AppStack';
import AppFlexbox from './AppFlexbox';

const PageFilter = ({ inputs }) => {
  const { isLargeMobileOrSmaller, isTabletOrSmaller } = useMediaQueryIndex();
  const [expandMobile, setExpandMobile] = useState(false);

  const switchToMobile =
    isLargeMobileOrSmaller || (isTabletOrSmaller && inputs.length >= 4);

  return (
    inputs && (
      <PageCard style={{ padding: 8 }}>
        <AppStack style={{ gap: 8, flex: 1 }}>
          <AppFlexbox style={{ gap: 8, flex: 1, alignItems: 'center' }}>
            {inputs[0]?.Component}

            {!switchToMobile
              ? inputs
                  .slice(1)
                  .map((input) => (
                    <React.Fragment key={input.key}>
                      {input.Component}
                    </React.Fragment>
                  ))
              : inputs.length > 1 && (
                  <AppStack>
                    <ActionIcon
                      color="dark"
                      onClick={() => setExpandMobile(!expandMobile)}
                      variant="subtle"
                    >
                      {expandMobile ? (
                        <ChevronUp size={20} />
                      ) : (
                        <ChevronDown size={20} />
                      )}
                    </ActionIcon>
                  </AppStack>
                )}
          </AppFlexbox>

          {switchToMobile &&
            expandMobile &&
            inputs
              .slice(1)
              .map((input) => (
                <React.Fragment key={input.key}>
                  {input.Component}
                </React.Fragment>
              ))}
        </AppStack>
      </PageCard>
    )
  );
};

PageFilter.propTypes = { inputs: PropTypes.array.isRequired };

export default PageFilter;
